import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import AddEditModule from "../../component/AddEditModuleComponent/AddEditModule";
import Header from "../../component/Header/Header";
import Footer from "../../component/Footer/Footer";
import Sidebar from "../Sidebar";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import "./AddEditModule.scss";
import { useNavigate } from "react-router-dom";
import { AiOutlineSearch } from "react-icons/ai";
import { addModuleAction } from "../../actions/moduleListAction";
import { useDispatch } from "react-redux";
import { NotificationManager } from "react-notifications";
import { tutorialmoduleListAction } from "../../actions/trainingAction";
import Loader from "../../component/loaderComponent/Loader";
import { safeEncode } from "../../common/encoder";
import { getVehicleAction } from "../../actions/getVehicle";
import { VehicleCategoryAction } from "../../actions/partcatelogueAction";
import { getVehiclelist_categoryAction } from "../../actions/getVehicle";
import {
  FormControl,
  InputLabel,
  Select,
  Checkbox,
  ListItemText,
  MenuItem,
  Button,
} from "@mui/material";
import { HTTP_STATUS } from "../../constants/httpstatus/HttpsStatus";
import { Modal } from "react-bootstrap";
import PoppupThumbnail from "../../component/PoppupThumbnail";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import PopupConfirmation from "../../component/PopupConfirmation/PopupConfirmation";

const AddEditModules = () => {
  const [selectedCheckbox, setSelectedCheckbox] = useState("");
  const [searchvalue, setSearchvalue] = useState("");
  const [fileName, setFileName] = useState([]);
  const [vehicleMenu, setVehicleMenu] = useState([]);
  const files = ['Video', 'PDF'];
  const { i18n, t } = useTranslation();
  const language = Cookies.get("language");

  const handleChangeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  const handleCheckboxChange = (event) => {
    setSelectedCheckbox(event.target.value);
  };
  const handleFiletypeChange = (event) => {
    setFileName(event.target.value);
  };
  const handleVehicleMenuChange = (event) => {
    setVehicleMenu(event.target.value);
  };

  const [state, setDataState] = useState({
    name: "",
    training_ids: "",
    description: "",
    attachment: "string",
    vehicle_category: ""
  });
  var paginationCount = 10;
  const [tutorialListData, settutorialList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingTutorialList, setIsLoadingTutorialList] = useState(false);
  const [startIndex, setStartIndex] = useState(1);
  const [count, setCount] = useState(1);
  const [page, setPage] = useState(1);
  const handlePageChange = (event, value) => {
    setPage(value);
  };
  const [file, setfile] = useState(null);
  const fileInputRef = useRef(null);
  const [getVehicleList, setGetVehicleList] = useState([])

  const handleFileUploads = (event) => {
    const files = event.target.files[0];
    setfile(files)
  };
  const [vehicleList, setVehicleList] = useState([]);

  useEffect(() => {
    handleChangeLanguage(language);
    VehicleCategoryListData();
    if (state.vehicle_category) {
      CategoryVehicleListData(state?.vehicle_category)
    }
    setVehicleMenu([]);
  }, [state?.vehicle_category]);
  useEffect(() => {
    tutorialData();
  }, [page]);

  async function VehicleCategoryListData() {
    setIsLoading(true);
    let response = await dispatch(VehicleCategoryAction());
    if (response == 200 || response != null) {
      setVehicleList(response.data.data.results);
    }
    setIsLoading(false);
  }

  const [getVehiclecatList, setGetVehiclecatList] = useState([]);
  const CategoryVehicleListData = async (id) => {
    setIsLoading(true);
    let response;
    if (!id) {
      setIsLoading(false);
      return;
    }
    response = await dispatch(getVehiclelist_categoryAction(id));
    if (response === 200 || response != null) {
      setGetVehiclecatList(response?.data?.data?.results);
    }
    setIsLoading(false);
  };

  const handleChange = (evt) => {
    const { name, value } = evt.target;

    if (name === 'vehicle_category') {
      setSearchvalue("");
      setDataState({
        ...state,
        [name]: value,
      });
    } else {
      setDataState({
        ...state,
        [name]: value.replace(/^ +/gm, ""),
      });
      updateCharsters();
    }
  };

  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);

  const handleCheckboxChanges = (event, dataId) => {
    const checkboxValue = event.target.value;
    let updatedCheckboxes = [...selectedCheckboxes];

    if (event.target.checked) {
      if (updatedCheckboxes.length < 5) {
        updatedCheckboxes.push(dataId);
      } else {
        event.target.checked = false;
        NotificationManager.error(t('validationmsg.selectlimit'));
      }
    } else {
      updatedCheckboxes = updatedCheckboxes.filter((id) => id !== dataId);
    }
    setSelectedCheckboxes(updatedCheckboxes);
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  async function filterSearch() {
    setPage(1);
    const defaultpage = 1;
    const vehicleList = vehicleMenu.map((data) => {
      return data.id;
    })
    const fileType = fileName.join(",").toLowerCase();
    const module_id = ""
    const newStartIndex = (page - 1) * paginationCount + 1;
    setStartIndex(newStartIndex);
    setIsLoading(true);
    let response = await dispatch(tutorialmoduleListAction(
      module_id,
      defaultpage,
      fileType,
      vehicleList,
      searchvalue));
    if (response?.status === HTTP_STATUS.SUCCESS) {
      setCount(Math.ceil(response?.data?.data?.count / paginationCount));
      settutorialList(response?.data?.data?.results);
      setTextCounts((response?.data?.data?.name)?.length)
      setIsLoading(false);
    }
  }

  const oncreateModule = async () => {
    setIsLoading(true);
    let apiReq = new FormData();
    apiReq.append("name", state.name);
    apiReq.append("description", state.description);
    selectedCheckboxes.forEach((value, index) => {
      apiReq.append(`training_ids`, value);
    });
    let response = await dispatch(addModuleAction(apiReq));
    if (response?.status === HTTP_STATUS.CREATED) {
      setIsLoading(false);
      NotificationManager.success(response?.data?.message);
      navigate(`/addmoduleconfirmation/${safeEncode(response?.data?.data?.id)}`);
      window.scroll(0, 0);
    } else if (response === undefined) {
      setIsLoading(false);
    }
  };

  async function tutorialData() {
    const module_id = "";
    const vehicleList = vehicleMenu.map((data) => {
      return data.id;
    })
    const fileType = fileName.join(",").toLowerCase();
    setIsLoadingTutorialList(true);
    const newStartIndex = (page - 1) * paginationCount + 1;
    setStartIndex(newStartIndex);
    let response = await dispatch(tutorialmoduleListAction(
      module_id,
      page,
      fileType,
      vehicleList,
      searchvalue));
    if (response?.status === HTTP_STATUS.SUCCESS) {
      setCount(Math.ceil(response?.data?.data?.count / paginationCount));
      setIsLoadingTutorialList(false);
      settutorialList(response?.data?.data?.results);
    }
    else if (response === undefined) {
      setIsLoadingTutorialList(false);
    }
  }
  const [textCounts, setTextCounts] = useState(0);
  function updateCharsters(e) {
    const text = document.getElementById("text2").value;
    setTextCounts(text?.length);
  }

  const [showThumbnail, setShowThumbnail] = useState(false);
  const [attachmenturl, setAttachmenturl] = useState("");
  const [attachmentType, setAttachmentType] = useState("");

  const OpenThumbnailPopup = (attachment, attachment_type) => {
    if (attachment_type === "pdf") {
      window.open(attachment, '_blank');
      NotificationManager.success("Pdf downloaded successfully !");
    }
    else {
      setShowThumbnail(true);
      setAttachmenturl(attachment);
      setAttachmentType(attachment_type);
    }

  }

  const CloseThumbnailPopup = () => {
    setShowThumbnail(false);
  }

  const [confirmationPopupShow, setConfirmationPopupshow] = useState(false);
  const handleConfirmationPopup = () => {
    setConfirmationPopupshow(true);
  };
  const handleAddModulePopupCloseButtons = () => {
    if (
      state?.name === "" ||
      state?.description === "" ||
      selectedCheckboxes.length === 0
    ) {
      navigate("/producttraining")
    }
    else {
      setConfirmationPopupshow(true);
    }
  };
  const closeModuleConfirmationPopup = () => {
    setConfirmationPopupshow(false);
  };

  useEffect(() => {
    if (!searchvalue) {
      tutorialData();
    }
  }, [searchvalue])

  return (
    <div className="AddEditModule_containers">
      <div className="AddEditModule_container">
        <div className="AddEditModulecontent">
          <div className="header_border">
            <p className="pgm-list-header-text"> TVS &gt; {t('training_module.trainingmodule')} &gt; {t('add_module.addModule')}</p>
          </div>
          <div className="AddEditModule_panel">
            <div className="panel-all">
              {t('add_module.addModule')}
              <button
                className="AddEditModule_Close"
                onClick={handleAddModulePopupCloseButtons}
              >
                {t('add_module.close')}
              </button>
            </div>
          </div>
          <div className="hero-section">
            <div className="title-input">
              <div class="input-wrapper">
                <label className="required" for="first">{t('add_module.moduleName')}</label>
                <div className="">
                  <textarea
                    type="text"
                    name="name"
                    value={state.name}
                    className="text-field"
                    placeholder={t('add_module.moduleNamePlaceholder')}
                    onChange={handleChange}
                    rows={10}
                    cols={50}
                    id="text2"
                    maxLength={100}
                  />
                  <p className='titles_textCount_add_edit_modules_page'>{textCounts}/100</p>
                </div>
              </div>
              <div class="input-wrapper">
                <label className="required" for="first">{t('add_module.description')}</label>
                <div className="">
                  <input
                    type="text"
                    name="description"
                    value={state.description}
                    className="text-field"
                    placeholder={t('add_module.description')}
                    onChange={handleChange}
                    rows={10}
                    cols={50}
                    maxLength={500}
                  />
                </div>
                <p className='titles_textCount_add_edit_modules_page'>{(state?.description)?.length || 0}/500</p>
              </div>
            </div>
            <div className="panel-text required">
              {t('add_module.maxContentLimit')} {selectedCheckboxes.length}/5
            </div>
            {isLoading ? (
              <Loader />
            ) : (
              <>
                <div className="modulePanel_checkbox">
                  <div className="multiple_dropdown_container">
                    <div className="parts_add_textfields">
                      <div className="pgmlistdropdown_div_module">
                        <div class="input-wrapper">

                          <FormControl className="module-form-select">
                            <label className="select_label">{t('add_module.selectFileTypeLabel')}</label>
                            <Select
                              className="module-select"
                              labelId="demo-multiple-checkbox-label"
                              id="demo-multiple-checkbox"
                              multiple
                              value={fileName}
                              onChange={handleFiletypeChange}
                              inputProps={{ className: "module_input" }}
                              renderValue={(selected) => selected.join(', ')}
                            >
                              {files.map((data) => (
                                <MenuItem key={data} value={data}>
                                  <Checkbox checked={fileName?.indexOf(data) > -1} />
                                  <ListItemText primary={data} />
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                    <div className="parts_add_textfields">
                      <div className="pgmlistdropdown_div_module">
                        <div class="input-wrapper">
                          <select
                            name="vehicle_category"
                            value={state.vehicle_category}
                            onChange={handleChange}
                            className="category_select"
                            required
                          >
                            <option className="default-option" value="">{t('tutorialtraining.vehiclecategory')}</option>
                            {vehicleList.map((data, i) => (
                              <option value={data.id}>{data.name}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="parts_add_textfields">
                      <div className="pgmlistdropdown_div_module">
                        <div class="input-wrapper">
                          <FormControl className="module-form-select">
                            <label className="select_label">{t('add_module.selectVehicle')}</label>
                            {(
                              <Select
                                className="module-select"
                                labelId="demo-multiple-checkbox-label"
                                id="demo-multiple-checkbox"
                                multiple
                                value={vehicleMenu}
                                onChange={handleVehicleMenuChange}
                                inputProps={{ className: "module_input" }}
                                renderValue={(selected) => {
                                  const selectedRoleNames = selected.map(
                                    (data) => data.name
                                  );
                                  return selectedRoleNames.join(", ");
                                }}
                                MenuProps={{
                                  PaperProps: {
                                    style: {
                                      maxHeight: '200px',
                                    },
                                  },
                                }}
                              >
                                {state.vehicle_category && getVehiclecatList.map((data) => (
                                  <MenuItem key={data.id} value={data}>
                                    {/* <Checkbox checked={vehicleMenu.includes(data.name)} /> */}
                                    <Checkbox
                                      checked={vehicleMenu.some(
                                        (item) => item.id === data.id
                                      )}
                                    />
                                    <ListItemText value={data.id} primary={data.name} />
                                  </MenuItem>
                                ))}
                              </Select>
                            )}
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="search-box">
                    <input
                      placeholder={t('add_module.search')}
                      class="search-input"
                      value={searchvalue}
                      onChange={(e) => setSearchvalue(e.target.value)}
                    />
                    <div className="search-icon">
                      <button
                        onClick={filterSearch}
                        className="module-search"
                        disabled={!searchvalue && fileName?.length === 0 && vehicleMenu?.length === 0 && !state?.vehicle_category}

                      >{t('add_module.search')}
                      </button>
                    </div>
                  </div>
                </div>
                <AddEditModule
                  tutorialListData={tutorialListData}
                  handleCheckboxChanges={handleCheckboxChanges}
                  selectedCheckboxes={selectedCheckboxes}
                  count={count}
                  page={page}
                  handlePageChange={handlePageChange}
                  isLoadingTutorialList={isLoadingTutorialList}
                  OpenThumbnailPopup={OpenThumbnailPopup}
                />
                <div className="AddEditmodel_panel">
                  <div className="panel-all">
                    <button
                      className="AddEditmodel_create"
                      onClick={handleConfirmationPopup}
                      disabled={
                        state?.name === "" ||
                        state?.description === "" ||
                        selectedCheckboxes.length === 0
                      }
                    >
                      {t('add_module.createModuleButton')}
                    </button>
                  </div>
                </div>
              </>
            )}
            <Modal
              className="expertise-modal montserrat-font"
              show={showThumbnail}
              onHide={CloseThumbnailPopup}
            >
              <Modal.Body className="p-0">
                <PoppupThumbnail
                  CloseThumbnailPopup={CloseThumbnailPopup}
                  attachmenturl={attachmenturl}
                  attachmentType={attachmentType}
                />
              </Modal.Body>
            </Modal>
            <div className="footer_div">
              <Footer />
            </div>
          </div>
        </div>
      </div>
      <Modal
        className="expertise-modal"
        show={confirmationPopupShow}
        onHide={closeModuleConfirmationPopup}
      >
        <Modal.Body>
          {confirmationPopupShow && (
            <PopupConfirmation
              handleConfirmationPopupClose={closeModuleConfirmationPopup}
              onSaveClick={oncreateModule}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddEditModules;
